<template>
  <div class="table-responsive" :class="{ 'tbl-inherit': overflowState }">

    <div style="width: 100%; overflow-x: visible;">
      <table class="table" v-show="!loading">
        <thead>
          <tr>
            <th></th>
            <th></th>
            <th class="text-center arrow-link">
              登録 / 更新日
              <i
                class="fa fa-long-arrow-up"
                :class="{ active: sortBy == 'joinedDate' }"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-long-arrow-down"
                :class="{ active: sortBy == '-joinedDate' }"
                aria-hidden="true"
              ></i>
            </th>
            <th class="text-center arrow-link">
              登録者情報
            </th>
            <th class="text-center arrow-link">
              在籍企業 / 直近職種
            </th>
            <th class="text-center">登録者がスカウトを希望している求人</th>
            <th class="text-center">メモ</th>
            <th class="text-center">ステータス</th>
            <!-- <th class="text-center">判定</th> -->
            <th class="text-center"></th>
          </tr>
        </thead>
        <tbody>
          <ApplicantRow
            v-for="(applicant, index) in applicants"
            v-bind:key="applicant.id"
            :applicant="applicant"
            :applicantIndex="index"
            :rowNumber="rowNumber(index)"
            @hidden="overflowState = 0"
            @shown="overflow"
            @changed="checkUncheckJobseeker"
            :isPendingReview="true"
          />
          <tr v-if="showEmptyMessage">
            <td colspan="100%" class="text-center">
              あなたに確認依頼されている登録者はいません
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    
    <div class="pagination-area" v-if="totalPages > 1">
      <paginate :total-page="totalPages" :callback="changePage" />
    </div>
    <Loader v-show="loading" />
  </div>
</template>

<script>
import ApplicantRow from './ApplicantRow.vue';
import Loader from '@/components/utils/Loader.vue';
import Paginate from '@/components/utils/Paginate.vue';
import { mapMutations, mapActions, mapState, mapGetters } from 'vuex';
import actions from '@/config/actions';
import mutations from '@/config/mutations';
import Api from '@/config/api';
import ApiService from '@/service/apiService';
import Alert from '@/components/utils/Alert.vue';

export default {
  name: 'PendingReviewList',
  components: { Paginate, Loader, ApplicantRow, Alert },
  data() {
    return {
      loading: false,
      pagination: {},
      sortKey: null,
      asc: true,
      overflowState: 0,
      errors: [],
      showEmptyMessage: false,
    };
  },
  created() {
    // Load pending review applicants with status '確認依頼中'
    this.setStatusModel(['確認依頼中']);
    this.load(this.buildParams(1));
  },
  computed: {
    ...mapGetters({
      isReviewer: 'isCreateReviewUser',
      currentUser: 'getCurrentUser',
      reviewLists: 'getReviewLists',
      assignedReviewLists: 'getAssignedReviewLists',
    }),
    ...mapState({
      applicants: ({ applicant }) => applicant.applicants,
      reloadApplicants: ({ applicant }) => applicant.reloadApplicants,
      searchParams: ({ applicant }) => applicant.searchParams,
      sortBy: ({ applicant }) => applicant.sortBy,
      page: ({ applicant }) => applicant.page,
      applicantsCount: ({ applicant }) => applicant.applicantsCount,
      jobseekerIds: ({ applicant }) => applicant.jobseekerIds,
      favoritesOnly: ({ applicant }) => applicant.favoritesOnly,
    }),
    isDepartmentAccount() {
      return !this.isReviewer;
    },
    assignedReviewListId() {
      if (!this.assignedReviewLists || !this.assignedReviewLists.length) return null;
      const firstAssigned = this.assignedReviewLists[0];
      return firstAssigned && firstAssigned._id ? firstAssigned._id : null;
    },
    totalPages() {
      const { pagination } = this;
      return pagination.total
        ? Math.ceil(pagination.total / pagination.perPage)
        : 0;
    },
    from() {
      return (
        (parseInt(this.pagination.current, 10) - 1) * this.pagination.perPage +
        1
      );
    },
    to() {
      return (
        (parseInt(this.pagination.current, 10) - 1) * this.pagination.perPage +
        this.applicants.length
      );
    },
  },
  methods: {
    ...mapActions([
      actions.applicant.LOAD_APPLICANTS,
      actions.applicant.LOAD_SELECTORS,
      'loadReviewLists',
      'loadAssignedReviewLists',
      'loadPreviewApplicants'
    ]),
    ...mapMutations([
      mutations.applicant.SET_APPLICANTS,
      mutations.applicant.CHANGE_SORT_COLUMN,
      mutations.applicant.SET_SELECTORS,
      'setApplicantCounts',
      'setPage',
      'setStatusModel',
      'setReloadApplicants'
    ]),
    overflow() {
      this.overflowState = 1;
    },
    checkAll() {
      this.isCheckAll = !this.isCheckAll;
      this.jobseekerIds = [];
      if (this.isCheckAll) {
        // Check all
        for (var key in this.applicants) {
          this.jobseekerIds.push(this.applicants[key].id);
        }
      }
    },
    isCheckedJobseeker(id) {
      return this.jobseekerIds.includes(id);
    },
    isCheckedApplicants() {
      return this.jobseekerIds.length ? true : false;
    },
    checkUncheckJobseeker(id) {
      const index = this.jobseekerIds.indexOf(id);
      console.log(index);
      if (index > -1) {
        this.jobseekerIds.splice(index, 1);
      } else {
        this.jobseekerIds.push(id);
      }
    },
    changePerPage(row) {
      const params = { rowPerPage: row == '20件' ? 20 : 50 };
      if (this.searchParams) Object.assign(params, this.searchParams);
      if (this.sortBy) Object.assign(params, { sortBy: this.sortBy });
      this.load(params);
    },
    sorting(key) {
      let column = '';
      if (this.sortKey !== null) {
        if (this.sortKey === key) {
          if (this.asc) {
            column = key;
            this.asc = false;
          } else {
            column = `-${key}`;
            this.asc = true;
          }
        } else {
          column = `-${key}`;
          this.asc = true;
        }
      } else {
        column = `-${key}`;
        this.asc = true;
      }
      this.sortKey = key;
      this[mutations.applicant.CHANGE_SORT_COLUMN](column);
    },
    async load(params = {}) {
      this.loading = true;
      this.errors = [];
      try {
        // Load review lists and assigned lists to get the assigned review list ID
        if (this.isReviewer || this.isAdmin) {
          this.loadReviewLists();
        }
        await this.loadAssignedReviewLists();

        // Check if user has an assigned review list
        if (this.isReviewer && !this.assignedReviewListId) {
          this.$router.push('/applicant');
          return;
        }

        params.review_list_id = this.assignedReviewListId;

        const res = await this.loadPreviewApplicants(params);
        if (this.isReviewer && res.data.data.length == 0) {
          this.$router.push('/applicant');
        }
        this[mutations.applicant.SET_APPLICANTS](res.data.data);
        this.showEmptyMessage = this.applicants.length === 0;
        this.pagination = res.data.meta.pagination || {};

        this.statusModel = this.searchParams.status
          ? this.searchParams.status
          : this.statusModel;

        this.showcount();
      } catch (error) {
        console.error(error);
        this.errors.push(error);
      } finally {
        this.loading = false;
        this.setReloadApplicants(false);
      }
    },
    buildParams(page = null) {
      const params = {};
      if (page) params.page = page;
      if (this.pagination.perPage == 50) params.rowPerPage = 50;
      if (this.searchParams) Object.assign(params, this.searchParams);
      if (this.sortBy) params.sort = this.sortBy;
      if (this.favoritesOnly) params.favorites = 1;
      params.isNewPanel = true;
      // Always filter by pending review status and assigned review list
      params.status = ['確認依頼中'];
      if (this.assignedReviewListId) {
        params.review_list_id = this.assignedReviewListId;
      }
      return params;
    },
    changePage(page) {
      this.setPage(page);
    },
    rowNumber(index) {
      return (
        index +
        1 +
        (parseInt(this.pagination.current, 10) - 1) * this.pagination.perPage
      );
    },
    showcount() {
      this.setApplicantCounts({
        total: this.pagination.total,
        from: this.from,
        to: this.to,
        perPage: this.pagination.perPage,
      });
    },
    parseErrorResponse(response) {
      if (response && response.data && response.data.errors) {
        this.errors = Object.values(response.data.errors).flat();
      } else {
        this.errors = ['エラーが発生しました'];
      }
    },
    async excludeFromReviewList() {
      this.errors = [];
      
      if (this.jobseekerIds.length == 0) {
        this.errors.push('登録者が選択されていません');
        return;
      }

      try {
        this.loading = true;
        
        // Remove from review list and change status to '未確認'
        await ApiService.put(Api.endpoints.REMOVE_FROM_REVIEW_LIST_MULTIPLE, {
          jobseekerIDs: this.jobseekerIds,
          status: '未確認',
          isNewPanel: true,
        });

        // Clear selections and reload data
        this.jobseekerIds = [];
        this.isCheckAll = false;
        this.load(this.buildParams(1));
        
        this.$bvToast.toast('選択された登録者を除外しました', {
          title: '成功',
          variant: 'success',
          solid: true,
        });
      } catch (error) {
        console.error('Error excluding applicants:', error);
        this.errors.push('除外処理中にエラーが発生しました');
      } finally {
        this.loading = false;
      }
    },

    handleExcludeCompleted() {
      // Reload data after exclusion
      this.load(this.buildParams(1));
    },
  },
  watch: {
    reloadApplicants: function() {
      // console.log(this.page);
      if (this.page === 1) {
        this.load(this.buildParams(1));
      } else {
        this.load(this.buildParams(this.page));
      }
    },
    favoritesOnly: function() {
      if (this.page === 1) this.load(this.buildParams(1));
      else this.setPage(1);
    },
    page: function(currentPage) {
      this.load(this.buildParams(currentPage));
    },
    sortBy: function(value) {
      if (this.page === 1) {
        this.load(this.buildParams(1));
      } else {
        this.setPage(1);
      }
    },
  },
};
</script>

<style scoped>
.client-listing-detail table th a {
  color: #036d6c;
  font-size: 12px;
  text-decoration: none !important;
}

.arrow-link i {
  color: #d0c2c2;
}

.arrow-link i.active {
  color: #036d6c;
}

th.arrow-link:hover {
  cursor: pointer;
  padding: 5px 7px !important;
}

.table-responsive {
  overflow-x: visible;
}

.showing-div p {
  margin-top: 10px;
  font-size: 14px;
}

/* Bulk operations styling */
.bulk-operations-section {
  padding: 15px 20px;
  background-color: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #e9ecef;
}

.bulk-operation-btn {
  min-width: 120px;
  font-size: 14px;
  font-weight: 500;
}

.bulk-operation-btn:hover {
  background-color: #6c757d;
  border-color: #6c757d;
}

/* Remove old bulk operation styles */
.listing-type-one {
  padding: 15px 0;
  border-bottom: 1px solid #e9ecef;
}

.bulk-action-btn {
  background-color: #dc3545;
  border-color: #dc3545;
  color: white;
  padding: 5px 15px;
  border-radius: 4px;
  font-size: 14px;
}

.bulk-action-btn:hover:not(:disabled) {
  background-color: #c82333;
  border-color: #bd2130;
}

.bulk-action-btn:disabled {
  background-color: #6c757d;
  border-color: #6c757d;
  cursor: not-allowed;
}

.btn-sm-drop {
  padding: 5px 15px;
  font-size: 14px;
}

.dd-button {
  min-width: 120px;
}
</style> 